export default {"src":"/_next/static/media/Acne and Acne Scars.46cf317f.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};